import { createAsyncThunk } from "@reduxjs/toolkit";
import coreAPIs from "services/api/core";

export const getTypesenseStreams = createAsyncThunk(`typesense/getTypesenseStreams`, async (payload) => {
  try {
    const response = await coreAPIs.getTypesenseStreams(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const getTypesenseClips = createAsyncThunk("typesense/getTypesenseClips", async (payload) => {
  try {
    const response = await coreAPIs.getTypesenseClips(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
